const localStorageSettingName = 'CanTabs';

// Shape shared with the legacy (localStorage-dependent) CANtabs sidebar that
// some clients still use alongside this version. The old sidebar reads
// `openTabs` from this same key and crashes if it's missing, so every value we
// write keeps that field present.
const defaultCanTabState = { menuState: 'open', openTabs: ['CANapps'], activeTab: '' };

export const getCanTabState = () => {
	const settings = localStorage.getItem(localStorageSettingName);
	let canTabSettings;
	if (settings === null) {
		canTabSettings = { ...defaultCanTabState };
		localStorage.setItem(
			localStorageSettingName,
			JSON.stringify(canTabSettings),
		);
	} else {
		canTabSettings = JSON.parse(settings);
	}
	return canTabSettings;
};

export const setCanTabState = (canTabSettings) => {
	localStorage.setItem(
		localStorageSettingName,
		JSON.stringify(canTabSettings),
	);
};

export const resetCanTabState = () => {
	const canTabSettings = { ...defaultCanTabState };
	localStorage.setItem(
		localStorageSettingName,
		JSON.stringify(canTabSettings),
	);
};

// Backwards compatibility: ensure the `CanTabs` key exists with the legacy
// shape (notably `openTabs`) so navigating to a page that still renders the old
// sidebar doesn't crash. Preserves any state the user already has.
export const ensureLegacyCanTabState = () => {
	let current = null;
	try {
		const stored = localStorage.getItem(localStorageSettingName);
		current = stored ? JSON.parse(stored) : null;
	} catch (error) {
		current = null;
	}

	if (current && Array.isArray(current.openTabs)) return;

	const merged = { ...defaultCanTabState, ...(current || {}) };
	if (!Array.isArray(merged.openTabs)) {
		merged.openTabs = [...defaultCanTabState.openTabs];
	}
	setCanTabState(merged);
};
